import { Link } from "react-router-dom";

export const Logo = ({ to = "/", testId = "brand-logo" }) => (
  <Link to={to} data-testid={testId} className="group flex items-center gap-3 shrink-0">
    <span className="relative grid h-9 w-9 place-items-center rounded-lg border border-cyan-400/40 bg-cyan-400/10 font-mono-tech text-sm font-medium text-cyan-300 transition-shadow duration-300 group-hover:shadow-[0_0_20px_rgba(0,240,255,0.45)]">
      B/
    </span>
    <span className="font-display text-[15px] font-semibold leading-tight tracking-tight text-white">
      Beall Digital<span className="text-cyan-300"> Group</span>
    </span>
  </Link>
);
